import React from 'react';

/**
 * Reusable premium table component matching high-end board/grid design.
 * Features:
 * - Glassmorphic container with soft border & subtle shadows
 * - Muted uppercase headers with vertical dividers
 * - Transparent body columns with bottom dividers & clean row hover effects
 * - Responsive horizontal scrolling
 */
export default function CommonTable({ headers = [], children, scrollable = false }) {
  return (
    <div className={`w-full bg-white/70 backdrop-blur-md rounded-2xl border border-slate-200/40 shadow-sm overflow-hidden ${scrollable ? 'flex flex-col h-full' : ''}`}>
      <div className={`w-full ${scrollable ? 'flex-1 min-h-0 overflow-auto' : 'overflow-x-auto'}`}>
        <table className="w-full border-collapse text-left">
          <thead className={scrollable ? 'sticky top-0 z-10' : ''}>
            <tr className="bg-slate-50/80 border-b border-slate-200/40 backdrop-blur-sm">
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="px-6 py-4 text-[10px] md:text-[11px] font-bold text-slate-400 uppercase tracking-wider border-r border-slate-200/30 last:border-r-0"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100/60 bg-transparent">
            {children}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/**
 * Helper to render first-column item with premium initial letter avatar badge
 */
export const TableRowAvatarCell = ({ title, subtitle, colorClass = 'bg-indigo-600 text-white' }) => {
  const initial = title ? title.charAt(0).toUpperCase() : '';
  return (
    <div className="flex items-center gap-3">
      <div className={`w-9 h-9 rounded-xl flex items-center justify-center font-bold text-sm shadow-sm select-none border border-white/20 ${colorClass}`}>
        {initial}
      </div>
      <div>
        <p className="font-semibold text-slate-800 text-sm">{title}</p>
        {subtitle && <p className="text-xs text-slate-400">{subtitle}</p>}
      </div>
    </div>
  );
};
